/**
 * Проверка строки на соответствие регулярному выражению
 * @param line - строка для проверки
 * @returns 
 */
export const checkByRegExp = (line: string) => {
    //Паттерны соответствия
    const patterns = {
        vin: /^[A-HJ-NPR-Z0-9]{17}$/,
        carNumber: /^[ABEKMHOPCTYXabekmhopctyx]\s?\d{3}\s?[ABEKMHOPCTYXabekmhopctyx]{2}\s?\d{2,3}(?:\s?RUS)?$/,
        bodyNumber: /^[A-Za-z0-9\-]{5,17}$/,
    };

    return Object.keys(patterns).find(key => 
        patterns[key as keyof typeof patterns].test(line)) as keyof typeof patterns | null;
};